// extracted by mini-css-extract-plugin
export var animationAbsolute = "_24-q";
export var animationRelative = "_24-p";
export var backdropBlur = "_24-0";
export var detailLabelCell = "_24-12";
export var detailTable = "_24-11";
export var detailValueCell = "_24-13";
export var docIconBox = "_24-1d";
export var docIconBoxMd = "_24-1f";
export var docIconBoxSm = "_24-1e";
export var docTypeRow = "_24-16";
export var docTypeRowInner = "_24-17";
export var dropdownMatchDatePicker = "_24-3";
export var evidenceCardContent = "_24-1c";
export var fileUploadSpin = "_24-j";
export var gorgiasOpenButton = "_24-15 _24-d";
export var gorgiasTicketCard = "_24-14";
export var heroModalFooterButton = "_24-18";
export var hiddenContainer = "_24-o";
export var iconPrimary = "_24-1g";
export var iconSecondary = "_24-1h";
export var iconTertiary = "_24-1i";
export var integrationCard = "_24-1";
export var integrationLogoBox = "_24-2";
export var mainColumnSticky = "_24-1b";
export var maxWidthContainer = "_24-19";
export var modalContentBody = "_24-a";
export var modalHeaderImage = "_24-5";
export var modalImageLabel = "_24-7";
export var modalImageOverlay = "_24-6";
export var modalImageSubtitle = "_24-9";
export var modalImageTitle = "_24-8";
export var modalImageWrapper = "_24-4";
export var modalStickyFooter = "_24-b";
export var removeButton = "_24-e";
export var sidebarColumn = "_24-1a";
export var spinner = "_24-i";
export var timelineLine = "_24-y";
export var timelineLineBlack = "_24-10 _24-y";
export var timelineLineGray = "_24-z _24-y";
export var timelineLineHeight = "_24-x";
export var tlDotActivate = "_24-u";
export var tlDotActivateAnim = "_24-t";
export var tlDotHide = "_24-s";
export var tlDotHideAnim = "_24-r";
export var tlLineActivate = "_24-w";
export var tlLineActivateAnim = "_24-v";
export var uploadHint = "_24-n";
export var uploadIconBox = "_24-k";
export var uploadLabel = "_24-m";
export var uploadText = "_24-l";
export var uploadZone = "_24-f";
export var uploadZoneCursorDefault = "_24-h";
export var uploadZoneCursorPointer = "_24-g";
export var uploadedFileRow = "_24-c";
export var viewButton = "_24-d";